import { format } from 'date-fns';
import * as React from 'react';
import { Col } from 'react-bootstrap';

import { saveDailyFormFilter } from '../../actions/dashboardAction';
import { showPlantListModal } from '../../actions/modalActions';
import { IDailyForms, IHistory } from '../../interfaces';
import { getFlaggedForms, getIndividualFormSummary } from '../../services/dashboardService';
import { splitDate } from '../../utils/generalUtils';
import { ChartFooterButtons } from '../reusableComponents/ChartComponents/ChartFooterButtons';
import { BarChart } from '../reusableComponents/ChartComponents/BarChart';
import { PieChart } from '../reusableComponents/ChartComponents/PieChart';
import { CustomToolTip } from '../reusableComponents/CustomToolTip';
import { RDatePicker } from '../reusableComponents/DatePicker';
import { RegionFilter } from '../reusableComponents/RegionFilter';
import { inspectionType, parentInspectionType  } from '../../constants/generals';


export interface IDailyChartProps {
    onFilter: Function;
    dailyForms: IDailyForms;
    activeDate: Date;
    activeRegion: string;
    dailyFormSummary: any;
    dailyFlaggedForms: any;
    history: IHistory;
    instance: any;
    resetFilters: boolean;
    showFilter: boolean;
    dailyFlaggedFormCount: string;
    quarterlyFilterDate: string;
    monthlyFilterDate: string;
}

export interface IDailyChartState {
    regionFilter: string;
    queryString: string;
    dailyFilterValue: Date;
}

export class DailyChart extends React.PureComponent<IDailyChartProps, IDailyChartState> {
    constructor(props: IDailyChartProps) {
        super(props);
        this.state = {
            dailyFilterValue: props.activeDate,
            regionFilter: '', queryString: 'daily'
        };
    }

    componentWillReceiveProps(nextProps: IDailyChartProps) {
        const queryString =
            `daily?date=${format(nextProps.activeDate, 'YYYY-MM-DD')}&&region=${nextProps.activeRegion}`;
        if (this.props.activeDate !== nextProps.activeDate) {
            this.setState({
                queryString,
                dailyFilterValue: nextProps.activeDate,
                regionFilter: nextProps.activeRegion
            });
        }
        if (this.props.activeRegion !== nextProps.activeRegion) {
            this.setState({
                queryString,
                regionFilter: nextProps.activeRegion
            });
        }
    }

    renderCustomToolTip = (e) => {
        return <CustomToolTip eventObject={e} />;
    }

    handleDateFilter = async (date) => {
        this.props.onFilter();
        const { mm, dd, yyyy } = splitDate(format(date, 'YYYY-MM-DD'));
        saveDailyFormFilter(date, this.state.regionFilter);
        await getIndividualFormSummary(mm, dd, yyyy, 'Daily', this.state.regionFilter, this.props.instance);
        await getFlaggedForms('dailyForm', mm, dd, yyyy, this.state.regionFilter, this);
        const queryString = `daily?date=${format(date, 'YYYY-MM-DD')}&&region=${this.props.activeRegion}`;
        /*tslint:disable-next-line*/
        const dashboardQueryString = `/dashboard?date=${format(this.props.activeDate, 'YYYY-MM-DD')}&&region=${this.props.activeRegion}&&monthly=${format(this.props.monthlyFilterDate, 'YYYY-MM-DD')}&&daily=${format(date, 'YYYY-MM-DD')}&&quarterly=${format(this.props.quarterlyFilterDate, 'YYYY-MM-DD')}`;
        this.setState({
            dailyFilterValue: date,
            queryString
        });
        this.props.history.push(dashboardQueryString);
        this.props.instance.setState({
            isLoading: false
        });
    }

    handleRegionFilter = async (formType, region) => {
        this.props.onFilter();
        const { mm, dd, yyyy } = splitDate(format(this.state.dailyFilterValue, 'YYYY-MM-DD'));
        saveDailyFormFilter(this.state.dailyFilterValue, region);
        await getIndividualFormSummary(mm, dd, yyyy, 'Daily', region);
        await getFlaggedForms('quarterlyForm', mm, dd, yyyy, region, this);
        this.setState({
            regionFilter: region,
        });
        this.props.instance.setState({
            isLoading: false
        });
    }

    // handleClickOnDailyForms = (data) => {
    //     const { dailyForms } = this.props;
    //     if (data.name === 'Incomplete') {
    //         showPlantListModal('dashboard', dailyForms.InCompletePlantIds, 'Incomplete Plants', 'DailyForm');
    //         return;
    //     } else if (data.name === 'Complete') {
    //         showPlantListModal('dashboard', (dailyForms.CompletePlantIds || []), 'Complete Plants', 'DailyForm');
    //         return;
    //     }
    // }
    handleClickOnDailyForms = (data, barColor: string) => {  
        const { dailyForms } = this.props; 
        if (barColor.toUpperCase() === '#DBDBDB') {
            //showPlantListModal('dashboard', (dailyForms[`${data.name}`]['InCompletePlantIds']), 'Incomplete Plants', `${data.name}`);
            showPlantListModal('dashboard', (dailyForms[parentInspectionType(data.name)]['InCompletePlantIds']), 'Incomplete Plants', `${parentInspectionType(data.name)}`);
        } else {
            //showPlantListModal('dashboard', (dailyForms[`${data.name}`]['CompletePlantIds']), 'Complete Plants', `${data.name}`);
            showPlantListModal('dashboard', (dailyForms[parentInspectionType(data.name)]['CompletePlantIds']) , 'Complete Plants', `${parentInspectionType(data.name)}`);
        }
    }
    renderDailyFormPercentage = () => {
        const { dailyForms } = this.props;
        if (dailyForms) {
            const total = (dailyForms.inComplete + dailyForms.complete) / 100;
            const completePercent = dailyForms.complete / total;
            return <div className="percent-container" >
                <h3>{Math.floor(completePercent || 0)} %</h3>
                Completed
            </div>;
        }
        return <div></div>;
    }

    render() { 
        return <Col sm={4} className="pie-chart-container" xs={12} style={styles.pieChartStyle}>
            <ChartTitle>Daily Form Summary</ChartTitle>
            {this.props.showFilter ? [
                <Filter
                    key="Date"
                    value={this.state.dailyFilterValue}
                    onApply={val => this.handleDateFilter(val)}
                    type="date"
                    children={< RegionFilter
                        selectedValue={this.state.regionFilter}
                        key="region"
                        onChange={this.handleRegionFilter} />
                    } />,
            ]
                : ''}
            {/* <PieChart
                onClick={this.handleClickOnDailyForms}
                customTooltip={e => this.renderCustomToolTip(e)}
                className="pie-chart-responsive"
                data={this.props.dailyFormSummary}
                dataKey="value" legends
            >
            </PieChart>
            {this.renderDailyFormPercentage()} */}
            <BarChart
                customTooltip={e => this.renderCustomToolTip(e)}
                onClick={(e, barColor) => { this.handleClickOnDailyForms(e, barColor); }}
                barColors={['#63AB66', '#DBDBDB']}
                dataKey={['Complete', 'Incomplete']}
                data={this.props.dailyFormSummary}
            />
            <ChartFooterButtons
                flaggedForms={this.props.dailyFlaggedFormCount}
                history={this.props.history}
                label="Daily"
                redirectTo={this.state.queryString}
                onClickFlaggedForms={() =>
                    showPlantListModal('flagged-forms', this.props.dailyFlaggedForms,
                        'Daily Flagged Forms', 'daily')}
            />
        </Col>;
    }
}

const Filter = ({ type, onApply, value, children }) => {
    return <div className="filter-container" >
        <RDatePicker
            value={new Date(value)}
            onChange={e => onApply(e.toString())} />
        {/* {children} */}
    </div>;
};

const ChartTitle = ({ children }) => {
    return <div className="chart-title" style={{ fontSize: '20px' }} >{children}</div>;
};

const styles = {
    pieChartStyle: {
        /* float: 'none', */
        display: 'inline-block',
        padding: '50px 0 130px 20px',
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Dashboard/DailyChart.tsx